var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","label":"","outlined":"","color":_vm.stato.colore,"title":_vm.item.status === 'failed' ? _vm.item.error : ''}},[(_vm.item.status === 'generating')?_c('v-progress-circular',{staticClass:"mr-1",attrs:{"indeterminate":"","size":"10","width":"2"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.stato.testo)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }